import GenericErrorPage from '../error/GenericErrorPage';

const GenericErrorApp: React.FC<React.PropsWithChildren> = () => {
  return <GenericErrorPage />;
};

export default GenericErrorApp;
